import React from 'react'

export default function EmployeeDashboard() {
  return (
    <div>
      Employee Dashboard
    </div>
  )
}
